// src/hooks/useSubscriptionStatus.ts
import { useQuery } from '@tanstack/react-query';
import type { AxiosResponse } from 'axios';
import {
  subscriptionStatus,
  SubscriptionStatusResponse,
} from '../services/subscriptionService';

/** subscriptionStatus() の返却データ中の subscription 部分 */
export type SubscriptionInfo = SubscriptionStatusResponse['subscription'];

/**
 * 現在ログイン中ユーザーのサブスクリプション状況を取得するフック
 */
export const useSubscriptionStatus = () => {
  return useQuery<SubscriptionInfo | null, Error>({
    queryKey: ['subscriptionStatus'],
    queryFn: async (): Promise<SubscriptionInfo | null> => {
      const res: AxiosResponse<SubscriptionStatusResponse> =
        await subscriptionStatus();
      return res.data.subscription;
    },
    staleTime: 5 * 60 * 1000, // 5 分間キャッシュを新鮮とみなす
    retry: 1, // エラー時に 1 回リトライ
    refetchOnWindowFocus: false, // フォーカス時の自動再フェッチを無効化
  });
};
